<script lang="ts">
  import { splitTitleAndCategory } from '$lib/utils/shopify/splitTitleAndCategory';

  import type { GetProductQuery } from '$gql/storefront/operations';
  import WishlistButton from '$components/wishlist-button.svelte';
  import { page } from '$app/stores';

  export let product: NonNullable<GetProductQuery['product']>;

  let className: string | undefined = undefined;
  export { className as class };

  const { title, category } = splitTitleAndCategory({
    title: product.title,
    titlesCategoriesExceptions: $page.data.titlesCategoriesExceptions
  });
</script>

<div class={className}>
  <div class="flex justify-between gap-4">
    <h1 class="flex flex-col text-xl font-semibold">
      {title}<span class="font-medium text-primary/40">{category}</span>
    </h1>

    <WishlistButton variant="icon" size="lg" class="p-0 self-start" productId={product.id} />
  </div>
</div>
